<template>
	<screen class="settings-view">
		<template slot="header">
			<ui-header type="dark" @click="onBack">
				<h2 slot="title">Settings</h2>
			</ui-header>
		</template>
		<div class="settings-inner">
			<div class="settings-row">
				<blank-tile
					@click.native="navigate({ name: 'accounts' }, 'forward')"
					:alert="unlinkedAccounts > 0"
				>
					<span slot="image"
						><img src="@/assets/linkedAccounts.svg"
					/></span>
					<span slot="title">Linked Accounts</span>
				</blank-tile>
				<blank-tile
					@click.native="navigate({ name: 'card' }, 'forward')"
				>
					<span slot="image"
						><img src="@/assets/donationCard.svg"
					/></span>
					<span slot="title">Donation Card</span>
				</blank-tile>
			</div>
			<div class="settings-row">
				<blank-tile
					@click.native="
						navigate({ name: 'settings.cap' }, 'forward')
					"
				>
					<span slot="image"><img src="@/assets/maxmin.svg" /></span>
					<span slot="title">Set Donation<br />Preferences</span>
				</blank-tile>
				<blank-tile
					@click.native="openOrganization"
					v-if="!exclusiveDomain"
				>
					<span slot="image"
						><img src="@/assets/selectedOrg.svg"
					/></span>
					<span slot="title">Selected<br />Organization</span>
				</blank-tile>
				<blank-tile @click.native="openSupport" v-else>
					<span slot="image"
						><img src="@/assets/feedback.svg"
					/></span>
					<span slot="title">Feedback</span>
				</blank-tile>
			</div>
			<div class="settings-row">
				<blank-tile
					@click.native="
						navigate({ name: 'settings.user' }, 'forward')
					"
				>
					<span slot="image"
						><img src="@/assets/updateEmail.svg"
					/></span>
					<span slot="title">Update User</span>
				</blank-tile>
				<blank-tile
					@click.native="
						navigate({ name: 'settings.password' }, 'forward')
					"
				>
					<span slot="image"
						><img src="@/assets/changePassword.svg"
					/></span>
					<span slot="title">Change Password</span>
				</blank-tile>
			</div>
			<div class="settings-row">
				<blank-tile
					@click.native="
						navigate({ name: 'settings.legal' }, 'forward')
					"
					v-if="exclusiveDomain"
				>
					<span slot="image"><img src="@/assets/legal.svg" /></span>
					<span slot="title">Legal</span>
				</blank-tile>
				<blank-tile @click.native="openSupport" v-if="!exclusiveDomain">
					<span slot="image"
						><img src="@/assets/feedback.svg"
					/></span>
					<span slot="title">Feedback</span>
				</blank-tile>
				<blank-tile
					v-if="!exclusiveDomain"
					@click.native="
						navigate({ name: 'settings.legal' }, 'forward')
					"
				>
					<span slot="image"><img src="@/assets/legal.svg" /></span>
					<span slot="title">Legal</span>
				</blank-tile>
				<blank-tile
					v-if="showDetails"
					@click.native="
						navigate({ name: 'settings.details' }, 'forward')
					"
				>
					<span slot="image"
						><img src="@/assets/hands_hero.svg"
					/></span>
					<span slot="title">App Details</span>
				</blank-tile>
			</div>
			<div class="settings-logout">
				<router-link
					:to="{ name: 'logout', params: { direction: 'up' } }"
					>Sign Out</router-link
				>
			</div>
			<logo />
		</div>
	</screen>
</template>

<script>
import { Intercom } from '@capacitor-community/intercom'
import { mapActions, mapGetters } from 'vuex'
import BlankTile from '../Main/BlankTile'
import Screen from '../../ui/Screen'
import UiHeader from '../../ui/Header'
import Logo from '../../ui/Logo'

const intercom = new Intercom()

export default {
	name: 'settings-view',
	components: { BlankTile, UiHeader, Screen, Logo },
	data() {
		return {
			exclusiveDomain: process.env.VUE_APP_INSTITUTION_UUID
		}
	},
	computed: {
		...mapGetters(['organization', 'unlinkedAccounts']),
		showDetails() {
			return process.env.NODE_ENV === 'development' || 'Staging'
		}
	},
	methods: {
		...mapActions(['logout']),
		onBack() {
			this.navigate({ name: 'home' }, 'back')
		},
		openSupport() {
			if (window && window.HubSpotConversations) {
				window.HubSpotConversations.widget.open()
			} else {
				intercom.displayMessenger()
			}
		},
		openShare() {
			const body =
				'Hey, you should download the RoundUp App. I use it to support ' +
				this.organization +
				" by giving my extra change I don't even think about it. Check it out: https://app.roundupapp.com"
			window.location.href = 'sms:?&body=' + encodeURI(body)
		},
		openFeedback() {
			window.location.href =
				'mailto:support@roundupapp.com?subject=Feedback%20-%20Round%20Up%20App'
		},
		openOrganization() {
			this.$swal({
				title: 'Selected Organization',
				text:
					'Your funds are currently going to support the efforts of ' +
					this.organization +
					'.',
				showCancelButton: true,
				cancelButtonText: 'Change',
				allowOutsideClick: false,
				allowEscapeKey: false
			}).then((result) => {
				if (!result.value) {
					this.$router.push({ name: 'settings.institution' })
				}
			})
		}
	}
}
</script>

<style lang="scss">
.settings-view {
	overflow: hidden;
	position: relative;
	.settings-inner {
		position: relative;
		margin-left: -35px;
		margin-right: -35px;
		padding: 10px 10px 0;
		z-index: 1;
		@media screen and (max-width: 480px) {
			margin-left: -25px;
			margin-right: -25px;
		}
		.settings-row {
			display: grid;
			grid-template-columns: 1fr 1fr;
			grid-column-gap: 10px;
		}
		a {
			padding: 20px 50px;
			display: block;
			border-bottom: 1px solid $lighter-grey;
			cursor: pointer;
			text-decoration: none;
			color: $blue;
			&:hover,
			&:focus {
				background: $lighter-grey;
				text-decoration: underline;
			}
		}
		.settings-logout {
			padding: 10px 0px;
			a {
				background: $red;
				color: $white;
				border-radius: 10px;
				box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
				text-align: center;
				padding: 20px;
			}
		}
	}
}
</style>
